<template>
  <div>
    <v-card class="mb-3">
      <v-card-title class="portal-deep-blue-bg">
        {{ $t("message.infoloc.sr", { value: "default" }) }}
      </v-card-title>
      <v-card-text class="mt-5">
        <v-data-table :items="srs" :headers="headerSrTable" :items-per-page="5" :search="search" dense>
          <template v-slot:top>
            <v-row>
              <v-col offset-md="8">
                <v-text-field v-model="search" append-icon="mdi-magnify"
                :label="$t('message.search', { value: 'default' })" single-line hide-details></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.reportdate`]="{ item }">
            {{ formatdate(item.reportdate) }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            {{ getSrStatusText(item.status) }}
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon @click="showSrDetails(item.ticketid)">
              mdi-eye
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    
    <v-row>
      <v-col>
        <v-card ref="kmHistory" class="mb-3">
          <v-card-title class="portal-deep-blue-bg">
            {{ $t("message.infoloc.hkm", { value: "default" }) }}
            <v-col class="py-0 text-right">
              <vue-excel-xlsx :data="kmDatas" :columns="getExportColumns" :file-name="'history_KM'"
              :file-type="'xlsx'" :sheet-name="'history'">
                <v-icon large color="green">mdi-file-excel</v-icon>
              </vue-excel-xlsx>
            </v-col>
          </v-card-title>
          <v-card-text class="mt-5">
            <v-data-table :items="kmDatas" :headers="headerMeterTable" :items-per-page="5" dense>
              <template v-slot:[`item.readingdate`]="{ item }">
                {{ formatdate(item.readingdate) }}
              </template>
              <template v-slot:[`item.readingsource`]="{ item }">
                {{ getSource(item.readingsource) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card ref="hmHistory" class="mb-3">
          <v-card-title class="portal-deep-blue-bg">
            {{ $t("message.infoloc.hhm", { value: "default" }) }}
            <v-col class="py-0 text-right">
              <vue-excel-xlsx :data="hmDatas" :columns="getExportColumns" :file-name="'history_HM'"
              :file-type="'xlsx'" :sheet-name="'history'">
                <v-icon large color="green">mdi-file-excel</v-icon>
              </vue-excel-xlsx>
            </v-col>
          </v-card-title>
          <v-card-text class="mt-5">
            <v-data-table :items="hmDatas" :headers="headerMeterTable" :items-per-page="5" dense>
              <template v-slot:[`item.readingdate`]="{ item }">
                {{ formatdate(item.readingdate) }}
              </template>
              <template v-slot:[`item.readingsource`]="{ item }">
                {{ getSource(item.readingsource) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="showSign" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
      <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
        <v-system-bar height="30" color="#fff" class="px-0 mb-3">
          <span></span>
          <v-spacer></v-spacer>
          <v-icon size="32" class="pt-5" @click="showSign = false">mdi-close</v-icon>
        </v-system-bar>
        <sr-info :attachments="attachments" :sr="sr"></sr-info>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SrInfo from "@/components/SrInfo.vue";
import { getSrStatusText } from "@/shared/Helper";
import { formatMagicDate } from "@/shared/DateHelper";
import MaximoService from "@/services/MaximoService";

export default {
  props: ['srs', 'kmDatas', 'hmDatas'],
  components: {
    SrInfo,
  },
  data () {
    return {
      search: '',
      showSign: false,
      attachments: [],
      sr: {},
    }
  },
  computed: {
    headerSrTable() {
      return [{
        text: this.$t("message.magic.id", { value: "default" }),
        value: "ticketid",
        sortable: true,
      },
      {
        text: this.$t("message.magic.description", { value: "default" }),
        value: "title",
        sortable: true,
      },
      {
        text: this.$t("message.magic.status", { value: "default" }),
        value: "status",
        sortable: true,
      },
      {
        text: this.$t("message.magic.date", { value: "default" }),
        value: "reportdate",
        sortable: true,
      },
      {
        text: this.$t("message.magic.details", { value: "default" }),
        value: "action",
        sortable: false,
      },
      ];
    },
    headerMeterTable() {
      return [{
        text: this.$t("message.magic.date", { value: "default" }),
        value: "readingdate",
        sortable: true,
      },
      {
        text: this.$t("message.magic.meter", { value: "default" }),
        value: "reading",
        sortable: true,
      },
      {
        text: this.$t("message.magic.source", { value: "default" }),
        value: "readingsource",
        sortable: true,
      },
      ];
    },
    getExportColumns() {
      return [{
        label: this.$t("message.page.loconumber", { value: "default" }),
        field: "assetnum",
      },
      {
        label: this.$t("message.magic.date", { value: "default" }),
        field: "readingdate",
        dataFormat: this.formatdate
      },
      {
        label: this.$t("message.magic.meter", { value: "default" }),
        field: "reading",
      },
      {
        label: this.$t("message.magic.source", { value: "default" }),
        field: "readingsource",
        dataFormat: this.getSource
      },
      ];
    },
  },
  methods: {
    formatdate(date) {
      return formatMagicDate(date, this.$i18n.locale);
    },
    getSrStatusText(state) {
      return this.$t(getSrStatusText(state), { value: "default" });
    },
    getSource(readingsource) {
      return readingsource == "CX_INTSAGE" ? 
        this.$t("message.pageHm.portalReal", { value: "default" }) :
        this.$t("message.pageHm.maintenanceReal", { value: "default" });
    },
    async showSrDetails(id) {
      this.sr = this.srs.find((e) => e.ticketid == id);
      await MaximoService.getAttachments(this.sr.ticketuid)
        .then((response) => {
          this.attachments = response.data;
          this.showAttachment = true;
        })
        .catch(() => {
          this.showAttachment = false;
        });
      this.showSign = true;
    },
    // TODO showSrDetails
  }
}
</script>